/*
 * File: NavigationMenu.js
 * Project: patient-portal
 *
 * Created by Nate Weber on 08/12/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Navigation menu used in the Topbar.
 */

import React from "react";
import {} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import BillingIcon from "@material-ui/icons/AccountBalance";

import NavigationMenuItem from "./NavigationMenuItem";

const useStyles = makeStyles({
  menu: {
    display: "flex"
  }
});

const model = [{ label: "Bill Pay", to: "bill-pay", icon: <BillingIcon /> }];

const NavigationMenu = () => {
  const classes = useStyles();

  return (
    <div className={classes.menu}>
      {model.map((item, index) => (
        <NavigationMenuItem key={index} {...item} />
      ))}
    </div>
  );
};

NavigationMenu.propTypes = {};

export default NavigationMenu;
